import Vue from 'vue'
import VueI18n from 'vue-i18n'

import zhCN from './zh'
import zhTW from './zh-TW'
import en from './en'
import vi from './vi'
import ja from './ja'
import th from './th'

Vue.use(VueI18n)

const messages = {
	'zh-CN': zhCN, // 简体中文
	'zh-TW': zhTW, // 繁体中文
	'en': en,
	'vi': vi,
	'ja': ja,
	'th': th,
}

export function getLanguage() {
	const chooseLanguage = localStorage.getItem('lang')
	// console.log('choose_lang: ' + chooseLanguage)
	if (chooseLanguage) {
		const locales = Object.keys(messages)
		for (const locale of locales) {
			if (chooseLanguage.indexOf(locale) > -1) {
				return locale
			}
		}
	}

	// if it has not chosen language
	const navigatorLanguage = navigator.language
	// console.log('nav_lang: ' + navigatorLanguage)
	const locales = Object.keys(messages)
	for (const locale of locales) {
		if (navigatorLanguage.indexOf(locale) > -1) {
			return locale
		}
	}

	return 'en'
}

export function checkLanguage(Language) {
	const locales = Object.keys(messages)
	for (const locale of locales) {
		if (Language.indexOf(locale) > -1) {
			return locale
		}
	}

	return 'en'
}

// 国际化
const i18n = new VueI18n({
	locale: getLanguage(),
	messages
})

export default i18n
